var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, persistent: "" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.enviar }
                },
                [_vm._v(" Editar ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Editar ativo" } }),
      _c("v-form", { ref: "form" }, [
        _c("div", { staticClass: "row simulador-editar-ativo" }, [
          _c(
            "div",
            { staticClass: "col-12 pb-0" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Ativo",
                  disabled: "",
                  loading: _vm.loading_info
                },
                model: {
                  value: _vm.ativo.nome_ativo,
                  callback: function($$v) {
                    _vm.$set(_vm.ativo, "nome_ativo", $$v)
                  },
                  expression: "ativo.nome_ativo"
                }
              })
            ],
            1
          ),
          ["Fundos", "RF"].includes(_vm.ativo.tipo) && !_vm.hideAlerts
            ? _c("div", { staticClass: "col-12 row pt-0" }, [
                _c("div", { staticClass: "col-6 py-0" }, [
                  _c("small", { staticClass: "text-secondary" }, [
                    _vm._v(
                      " Aplic. Mínima: " + _vm._s(_vm.toMoney(_vm.aplMin)) + " "
                    )
                  ])
                ]),
                _vm.ativo.tipo === "Fundos"
                  ? _c("div", { staticClass: "col-6 py-0" }, [
                      _c("small", { staticClass: "text-secondary" }, [
                        _vm._v(
                          " Saldo de Perm.: " +
                            _vm._s(_vm.toMoney(_vm.ativo.saldo_permanencia)) +
                            " "
                        )
                      ])
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "col-6 py-0" }, [
                  _c("small", { staticClass: "text-secondary" }, [
                    _vm._v(
                      " Janela de tempo: " +
                        _vm._s(
                          _vm.infoAtivo.numero_meses
                            ? _vm.infoAtivo.numero_meses + " meses"
                            : "-"
                        ) +
                        " "
                    )
                  ])
                ]),
                _c("div", { staticClass: "col-6 py-0" }, [
                  _c("small", { staticClass: "text-secondary" }, [
                    _vm._v(
                      " Qualificado: " +
                        _vm._s(_vm.ativo.qualificado ? "Sim" : "Não") +
                        " "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.ativo.referencia && _vm.ativo.tipo === "Fundos" && !_vm.hideAlerts
            ? _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("v-text-field", {
                    attrs: { label: "CNPJ", disabled: "" },
                    model: {
                      value: _vm.ativo.referencia,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "referencia", $$v)
                      },
                      expression: "ativo.referencia"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.ativo.tipo === "Fundos" && !_vm.hideAlerts
            ? _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("v-checkbox", {
                    attrs: { label: "Usar master" },
                    model: {
                      value: _vm.master,
                      callback: function($$v) {
                        _vm.master = $$v
                      },
                      expression: "master"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.master && !_vm.hideAlerts
            ? _c(
                "div",
                { staticClass: "col-5" },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: ["##.###.###/####-##"],
                        expression: "['##.###.###/####-##']"
                      }
                    ],
                    attrs: {
                      label: "CNPJ master*",
                      rules: [_vm.rules.required, _vm.rules.cnpj]
                    },
                    model: {
                      value: _vm.ativo.master,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "master", $$v)
                      },
                      expression: "ativo.master"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.openClass
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Classe*",
                      required: "",
                      rules: [_vm.rules.required]
                    },
                    model: {
                      value: _vm.ativo.classe,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "classe", $$v)
                      },
                      expression: "ativo.classe"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.openClass
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("v-select", {
                    attrs: { label: "Classe", items: _vm.classes_simulador },
                    model: {
                      value: _vm.ativo.classe,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "classe", $$v)
                      },
                      expression: "ativo.classe"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showSubclass
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("v-select", {
                    attrs: {
                      label: "Subclasse",
                      items: _vm.subclasses,
                      "item-text": "subclasse",
                      "item-value": "subclasse"
                    },
                    model: {
                      value: _vm.ativo.subclasse,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "subclasse", $$v)
                      },
                      expression: "ativo.subclasse"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "col-6 d-flex",
              staticStyle: { "align-items": "flex-end" }
            },
            [
              _c("v-select", {
                staticStyle: { "max-width": "50px" },
                attrs: {
                  items: ["R$", "%"],
                  disabled: !!_vm.modo_unico_ativos
                },
                on: { change: _vm.$forceUpdate },
                model: {
                  value: _vm.mode,
                  callback: function($$v) {
                    _vm.mode = $$v
                  },
                  expression: "mode"
                }
              }),
              _vm.show
                ? _c("v-currency-field", {
                    ref: "edit-valor",
                    attrs: { "allow-negative": false },
                    model: {
                      value: _vm.valor,
                      callback: function($$v) {
                        _vm.valor = $$v
                      },
                      expression: "valor"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm.actualClass.percent &&
          _vm.actualClass.percent > _vm.actualClass.alocado
            ? _c(
                "div",
                { staticClass: "col-12 pt-0 d-flex" },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "50%" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { "x-small": "" },
                          on: { click: _vm.adjustByGeneral }
                        },
                        [
                          _vm._v(
                            " Disponível: " +
                              _vm._s(
                                _vm.toPercent(100 * (_vm.plLivre / _vm.plTotal))
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { "x-small": "" },
                      on: { click: _vm.adjustByClass }
                    },
                    [
                      _vm._v(
                        " Ainda disponível na " +
                          _vm._s(_vm.showSubclass ? "subclasse" : "classe") +
                          ": " +
                          _vm._s(
                            _vm.toPercent(
                              _vm.actualClass.percent - _vm.actualClass.alocado
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.plTotal && !_vm.hideAlerts
            ? _c("div", { staticClass: "col-12 pt-0 d-flex" }, [
                _c("div", { staticStyle: { width: "50%" } }, [
                  _c("small", { staticClass: "text-secondary" }, [
                    _vm._v(
                      " P/L Simulação: " +
                        _vm._s(_vm.toMoney(_vm.plTotal)) +
                        " "
                    )
                  ])
                ]),
                _c("small", { staticClass: "text-secondary" }, [
                  _vm._v(
                    " P/L Não alocado: " +
                      _vm._s(_vm.toMoney(_vm.plLivre)) +
                      " "
                  )
                ])
              ])
            : _vm._e(),
          _vm.showAlets && !_vm.hideAlerts
            ? _c("div", { staticClass: "col-12 pt-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "elevation-1 text-dark",
                    staticStyle: {
                      padding: "7px",
                      "border-radius": "12px",
                      "font-weight": "normal",
                      background: "#fff9c4 !important"
                    }
                  },
                  [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm.alertJanelaTempo
                        ? _c("small", [
                            _vm._v(
                              " - Este ativo não supre a restrição de janela de tempo. Caso não aumente a janela de tempo, ele irá ser desconsiderado na análise. "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm.alertSaldoPerm
                        ? _c("small", [
                            _vm._v(
                              " - Valor informado é menor que o saldo de permanência do ativo (" +
                                _vm._s(
                                  _vm.toMoney(_vm.ativo.saldo_permanencia)
                                ) +
                                "). "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm.alertAplMin
                        ? _c("small", [
                            _vm._v(
                              " - Valor informado é menor que a aplicação minima do ativo (" +
                                _vm._s(_vm.toMoney(_vm.aplMin)) +
                                "). "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm.alertQualificado
                        ? _c("small", [
                            _vm._v(
                              " - Este ativo está disponível somente para clientes "
                            ),
                            _c("i", [_vm._v(" qualificados. ")]),
                            _vm._v(
                              " O cliente selecionado não se encaixa na restrição. "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              ])
            : _vm._e(),
          ["Operações Estruturadas", "Renda Fixa"].includes(_vm.ativo.tipo) &&
          !_vm.hideAlerts
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: _vm.maskData,
                        expression: "maskData"
                      }
                    ],
                    attrs: {
                      label:
                        _vm.ativo.tipo === "Operações Estruturadas"
                          ? "Data de observação"
                          : "Data de carência",
                      "persistent-hint": "",
                      "prepend-inner-icon": "event"
                    },
                    model: {
                      value: _vm.ativo.data_carencia,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "data_carencia", $$v)
                      },
                      expression: "ativo.data_carencia"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          ["Operações Estruturadas", "Renda Fixa"].includes(_vm.ativo.tipo) &&
          !_vm.hideAlerts
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("v-select", {
                    attrs: { label: "Rating", items: _vm.RATINGS },
                    model: {
                      value: _vm.ativo.rating,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "rating", $$v)
                      },
                      expression: "ativo.rating"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.ativo.tipo === "Renda Fixa" && !_vm.hideAlerts
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("v-checkbox", {
                    attrs: { label: "Carência diária" },
                    model: {
                      value: _vm.ativo.carencia_diaria,
                      callback: function($$v) {
                        _vm.$set(_vm.ativo, "carencia_diaria", $$v)
                      },
                      expression: "ativo.carencia_diaria"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.recomendacaoOptions,
                  "item-text": "text",
                  "item-value": "value",
                  label: "Recomendação",
                  clearable: ""
                },
                model: {
                  value: _vm.ativo.recomendacao,
                  callback: function($$v) {
                    _vm.$set(_vm.ativo, "recomendacao", $$v)
                  },
                  expression: "ativo.recomendacao"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("v-text-field", {
                attrs: { label: "Setor", clearable: "" },
                model: {
                  value: _vm.ativo.setor,
                  callback: function($$v) {
                    _vm.$set(_vm.ativo, "setor", $$v)
                  },
                  expression: "ativo.setor"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 simulador-editar-ativo__tags" },
            [
              _c("div", { staticClass: "az-text-small mb-2" }, [
                _vm._v(" Tags ")
              ]),
              _c("ClientTags", {
                attrs: {
                  tags: _vm.ativo.tags,
                  loading: _vm.loading,
                  canEdit: "",
                  showTextNoTag: ""
                },
                on: {
                  "add-tag": _vm.handleAddTag,
                  "remove-tag": _vm.handleRemoveTag
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 simulador-editar-ativo__description" },
            [
              _c("div", { staticClass: "az-text-small mb-2" }, [
                _vm._v(" Comentário ")
              ]),
              _c("input-by-type", {
                staticClass: "new-ux",
                attrs: { type: "textarea", outlined: "", "hide-details": "" },
                model: {
                  value: _vm.ativo.comentario,
                  callback: function($$v) {
                    _vm.$set(_vm.ativo, "comentario", $$v)
                  },
                  expression: "ativo.comentario"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }